import { Controller } from '@hotwired/stimulus';
import { CarouselController } from '@elc-online/edl-components/js/carousel';

export default class extends Controller {
  static readonly targets = [
    'container',
    'previous',
    'next',
    'items',
    'navigation',
  ];

  declare containerTarget: HTMLElement;
  declare previousTarget: HTMLButtonElement;
  declare nextTarget: HTMLButtonElement;
  declare itemsTarget: HTMLElement;
  declare navigationTarget: HTMLElement;

  initialize(): void {
    new CarouselController(
      {
        container: this.containerTarget,
        previous: this.previousTarget,
        next: this.nextTarget,
        items: this.itemsTarget,
        navigation: this.navigationTarget,
      },
      { mode: 'auto' },
    );
  }
}
